import {TerceroUPPasarelaTarifa} from './tercero-up-pasarela-tarifa';

export type AdmsbTipoTarifa = 'porcentaje' | 'moneda';

export interface AdmsbConceptoTarifaDef {
  campo: string;
  campoBase: string;
  labelClave: string;
  tipo: AdmsbTipoTarifa;
}

export interface AdmsbConceptoTarifa {
  campo: string;
  tarifaBase: number;
  tarifaPreferencial: number;
}

export interface AdmsbMedioTarifa {
  id: string;
  nombre: string;
  conceptos: AdmsbConceptoTarifa[];
  raw?: TerceroUPPasarelaTarifa;
}

export interface AdmsbCanalTarifa {
  id: string;
  nombre: string;
  medios?: AdmsbMedioTarifa[];
}

export const ADMSB_CONCEPTOS_TARIFA: AdmsbConceptoTarifaDef[] = [
  {
    campo: 'tarifaTrxVentaPorcentaje',
    campoBase: 'configTarifaTrxVentaPorcentaje',
    labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFATRXVENTA',
    tipo: 'porcentaje'
  },
  {
    campo: 'tarifaTrxIndividual',
    campoBase: 'configTarifaTrxIndividual',
    labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFATRXINDIVIDUAL',
    tipo: 'moneda'
  },
  {
    campo: 'montoMinimoTrx',
    campoBase: 'configMontoMinimoTrx',
    labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MONTOMINIMOTRX',
    tipo: 'moneda'
  },
  {
    campo: 'montoMaximoTrx',
    campoBase: 'configMontoMaximoTrx',
    labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MONTOMAXIMOTRX',
    tipo: 'moneda'
  },
  {
    campo: 'montoMaximoMes',
    campoBase: 'configMontoMaximoMes',
    labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MONTOMAXIMOMES',
    tipo: 'moneda'
  },
  {
    campo: 'limiteTrxDiario',
    campoBase: 'configLimiteTrxDiario',
    labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_LIMITETRXDIA',
    tipo: 'moneda'
  },
  {campo: 'limiteTrxMes', campoBase: 'configLimiteTrxMes', labelClave: 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TRXMES', tipo: 'moneda'},
];
